import React from 'react'
import PropTypes from 'prop-types'
import { Box, Image } from 'theme-ui'

import { Icon } from 'ui'

function TimelineItem({ assets, date, title, code }) {
  const pdfIcon = {
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27.44 32.76'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='.5' y1='-.07' x2='.5' y2='.94' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23f1f5f9'/%3E%3Cstop offset='1' stop-color='%23d8e5f4'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg data-name='Layer 3'%3E%3Cpath data-name='Trazado 147' d='M20.361 30.985H4.426A4.426 4.426 0 010 26.558V4.426A4.426 4.426 0 014.426 0H15.51a5.312 5.312 0 013.78 1.567L23.221 5.5a5.312 5.312 0 011.567 3.8v17.258a4.426 4.426 0 01-4.426 4.426z' fill='%23e1eaf6'/%3E%3Cpath data-name='Trazado 148' d='M30.361 38.485H14.426A4.426 4.426 0 0110 34.058V11.926A4.426 4.426 0 0114.426 7.5H25.51a5.312 5.312 0 013.78 1.567L33.221 13a5.312 5.312 0 011.567 3.8v17.258a4.426 4.426 0 01-4.427 4.427z' transform='translate(-10 -5.729)' fill='url(%23a)'/%3E%3Cpath data-name='Trazado 149' d='M4.347 25.133a1.16 1.16 0 01-.345-.885 3.594 3.594 0 011.48-2.399 11.942 11.942 0 013.638-2.1 15.758 15.758 0 00.708-4.028 11.137 11.137 0 01-2.746-3.681 6.622 6.622 0 01-.416-2.116 2.4 2.4 0 01.31-1.266 1.2 1.2 0 01.992-.6c1.08.071 1.841 1.062 2.452 2.727a13.226 13.226 0 01.562 4.071v.407a22.964 22.964 0 004.117 2.939c.965-.2 1.9-.39 2.727-.575a8.5 8.5 0 011.894-.239 3.435 3.435 0 011.655.345 1.319 1.319 0 01.761 1.133c-.1 1.16-1.284 1.771-2.895 1.771a7.171 7.171 0 01-1.425-.15 12.517 12.517 0 01-2.851-1.053 41.283 41.283 0 00-4.754 1.213l-.168.062a7.33 7.33 0 01-3.966 4.524 2.408 2.408 0 01-.885.177 1.231 1.231 0 01-.841-.31zm.885-.885a1.319 1.319 0 00.46-.1 5.4 5.4 0 002.833-2.868 9.738 9.738 0 00-2.257 1.443 2.762 2.762 0 00-1.08 1.523h.044zm12.836-4.949a6.2 6.2 0 001.2.124 2.859 2.859 0 001.434-.3c.292-.159.31-.283.3-.292a.363.363 0 00-.133-.115 2.319 2.319 0 00-1.1-.195 7.5 7.5 0 00-1.638.2l-1.213.266a7.41 7.41 0 001.16.319zm-7.587 0c.938-.283 1.956-.54 2.983-.77a23.213 23.213 0 01-2.532-1.824 17.29 17.29 0 01-.45 2.594zM7.968 9.216l-.053.053a1.239 1.239 0 00-.133.655 5.382 5.382 0 00.354 1.771 7.188 7.188 0 001.673 2.461 11.04 11.04 0 00-.487-2.957 4.772 4.772 0 00-.832-1.576.965.965 0 00-.513-.372z' fill='%23eff4f9'/%3E%3Cpath data-name='Trazado 150' d='M4.346 24.248a1.16 1.16 0 01-.345-.841 3.594 3.594 0 011.48-2.399 11.942 11.942 0 013.638-2.1 15.758 15.758 0 00.708-4.028 11.137 11.137 0 01-2.746-3.725 6.622 6.622 0 01-.416-2.116 2.4 2.4 0 01.31-1.266 1.2 1.2 0 01.992-.6c1.08.071 1.841 1.062 2.452 2.727a13.226 13.226 0 01.562 4.071v.407a22.964 22.964 0 004.117 2.939c.965-.2 1.9-.39 2.727-.575a8.5 8.5 0 011.894-.239 3.435 3.435 0 011.655.345 1.319 1.319 0 01.761 1.133c-.1 1.16-1.284 1.771-2.895 1.771a7.17 7.17 0 01-1.425-.15 12.518 12.518 0 01-2.851-1.053 41.279 41.279 0 00-4.754 1.213l-.168.062a7.33 7.33 0 01-3.966 4.524 2.408 2.408 0 01-.885.177 1.231 1.231 0 01-.841-.31zm.885-.885a1.319 1.319 0 00.46-.1 5.4 5.4 0 002.833-2.868 9.738 9.738 0 00-2.257 1.443 2.762 2.762 0 00-1.08 1.523h.044zm12.836-4.949a6.2 6.2 0 001.2.124 2.86 2.86 0 001.434-.3c.292-.159.31-.283.3-.292a.363.363 0 00-.133-.115 2.319 2.319 0 00-1.1-.195 7.5 7.5 0 00-1.638.2l-1.213.266a7.41 7.41 0 001.16.319zm-7.587 0c.938-.283 1.956-.54 2.983-.77a23.212 23.212 0 01-2.532-1.824 17.29 17.29 0 01-.45 2.594zM7.967 8.331l-.053.053a1.239 1.239 0 00-.133.655 5.382 5.382 0 00.354 1.771 7.188 7.188 0 001.673 2.461 11.039 11.039 0 00-.487-2.957 4.772 4.772 0 00-.832-1.576.965.965 0 00-.513-.372z' fill='%23a7c1db'/%3E%3Cpath data-name='Trazado 151' d='M23.018 9.298h-4.577a2.063 2.063 0 01-2.063-2.066V3.541a.443.443 0 11.885 0v3.692A1.177 1.177 0 0018.44 8.41h4.578a.443.443 0 110 .885z' fill='%23a7c1db'/%3E%3Crect data-name='Rectángulo 264' width='15.87' height='7.76' rx='1.91' transform='translate(11.571 22.876)' fill='%23ec5d24'/%3E%3Cpath data-name='Trazado 152' d='M15.82 27.001h-.77v1.151a.531.531 0 01-.115.372.417.417 0 01-.593 0 .549.549 0 01-.115-.372v-3.1a.5.5 0 01.124-.381.575.575 0 01.4-.124h1.062a2.5 2.5 0 01.717.08.983.983 0 01.434.23 1.036 1.036 0 01.274.39 1.408 1.408 0 01.089.522 1.142 1.142 0 01-.381.938 1.682 1.682 0 01-1.126.294zm-.2-1.868h-.567v1.239h.558a1.9 1.9 0 00.484-.053.575.575 0 00.3-.2.629.629 0 00.1-.363.593.593 0 00-.161-.437 1.027 1.027 0 00-.717-.15z' fill='%23fff'/%3E%3Cpath data-name='Trazado 153' d='M18.537 24.549h1.071a2.815 2.815 0 01.717.08 1.381 1.381 0 01.549.292 2.08 2.08 0 01.629 1.655 3.135 3.135 0 01-.062.664 2.116 2.116 0 01-.195.549 1.771 1.771 0 01-.345.434 1.284 1.284 0 01-.354.23 1.328 1.328 0 01-.416.124 2.894 2.894 0 01-.5 0H18.59a.717.717 0 01-.345-.071.292.292 0 01-.142-.195 1.053 1.053 0 010-.319v-2.938a.513.513 0 01.115-.381.54.54 0 01.319-.124zm.319.655v2.762h.947a.885.885 0 00.239-.053.637.637 0 00.212-.124 1.514 1.514 0 00.416-1.2 1.771 1.771 0 00-.186-.885.8.8 0 00-.442-.385 2.258 2.258 0 00-.646-.08z' fill='%23fff'/%3E%3Cpath data-name='Trazado 154' d='M24.655 25.231h-1.638v1.045h1.354a.434.434 0 01.283.08.31.31 0 010 .451.434.434 0 01-.283.08h-1.354v1.346a.5.5 0 01-.115.372.417.417 0 01-.593 0 .5.5 0 01-.115-.372v-3.179a.646.646 0 01.053-.283.31.31 0 01.168-.168.646.646 0 01.283-.053h1.939a.443.443 0 01.292.089.274.274 0 01.1.23.266.266 0 01-.1.23.4.4 0 01-.274.132z' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E\")",
    backgroundRepeat: 'no-repeat',
    height: [25, 30],
    width: [23, 28],
  }

  return (
    <div>
      <Box
        sx={{
          width: ['124px', '151px'],
          bg: 'white',
          borderRadius: '5px',
          boxShadow: '0px 3px 6px #00000029',
          mb: 'small',
          p: 'small',
        }}
      >
        <Box sx={{ display: 'flex', mb: 'xsmall', gap: [1, 2] }}>
          {assets?.map(asset =>
            asset?.video ? (
              <Box
                as='a'
                href={asset?.video}
                id={`video-${date.replace(' ', '-')}`}
                sx={{
                  flex: 1,
                  display: 'flex',
                  alignContent: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '5px',
                  height: 61,
                  position: 'relative',
                }}
                target='_blank'
              >
                <Icon
                  name='fa-youtube'
                  sx={{
                    color: 'white',
                    position: 'absolute',
                    height: '25px',
                    width: '25px',
                  }}
                />
                <Image
                  sx={{ height: '100%', objectFit: 'cover' }}
                  src={asset.thumbnail}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  bg: 'red',
                  flex: 1,
                  borderRadius: '5px',
                  height: 61,
                  display: 'flex',
                  alignContent: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                as='a'
                href={asset?.document}
                target='_blank'
                id={`${code}-pdf-${date.replace(' ', '-')}`}
              >
                <Box sx={pdfIcon} />
              </Box>
            )
          )}
        </Box>

        <Box sx={{ fontSize: 0, textAlign: 'center' }}>{title}</Box>
        <Box
          sx={{
            color: 'neutral',
            fontFamily: 'heading',
            fontSize: [1, 3],
            fontWeight: 'heading',
            textAlign: 'center',
            textTransform: 'capitalize',
          }}
        >
          {date}
        </Box>
      </Box>

      <Box
        sx={{
          bg: '#36a54c',
          height: '20px',
          width: '20px',
          borderRadius: '50%',
          border: '4px solid',
          mx: 'auto',
          borderColor: '#80c343',
        }}
      />
    </div>
  )
}

TimelineItem.defaultProps = {
  assets: [],
  title: 'Avance de obra',
}

TimelineItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  assets: PropTypes.array,
  date: PropTypes.string.isRequired,
  title: PropTypes.string,
}

export default TimelineItem
